import { render, staticRenderFns } from "./SinisterDetail.vue?vue&type=template&id=3412c8ea"
import script from "./SinisterDetail.vue?vue&type=script&lang=js"
export * from "./SinisterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Reports/BudgetReport/SinisterDetail.vue
// module id = 2203
// module chunks = 31